import { AddressMhs } from "./address-mhs";

export class PhysicianMhs {
    hasPhysician: string;
    medicalFacility?: string;
    physicianFirstName?: string;
    physicianLastName?: string;
    phoneNumber: string;
    address: AddressMhs;
    lastConsultDate: string;
    lastConsultReason: string;
}